import { Dispatch, SetStateAction } from 'react'
import { ReactComponent as ChartIcon } from '../../../assets/Icons/adornments/BarChart.svg';
import { ReactFlowProvider } from "@xyflow/react";
import { ReadAcrossDataType } from '../page/IndividualReadAcrossPage';
import RAFlowChart from './FlowChartComponents/RAFlowChart';
import { Skeleton } from '@mui/material';



export default function RANearestNeighbors({
    readacrossData,
    isLoading,
    selectedFilter,
    setSelectedFilter,
    searchInput,
    setSearchInput,
}: {
    readacrossData: ReadAcrossDataType[],
    isLoading: boolean,
    selectedFilter: string,
    setSelectedFilter: Dispatch<SetStateAction<string>>,
    searchInput: string,
    setSearchInput: Dispatch<SetStateAction<string>>,
}) {

    

    return (
        <div className="w-full grow h-full flex flex-col justify-start items-stretch bg-white rounded-2xl border border-outline">
            {isLoading ? (
                <div className='p-6 w-full h-full'>
                    <Skeleton variant='rounded' width='100%' height='100%' />
                </div>
            ) : (
            <>
                <div className="w-full flex justify-between items-center gap-8 p-6">
                    <div className="flex gap-2">
                        <div className="w-[20px] text-disable"><ChartIcon /></div>
                        <p className="text-default font-semibold text-[20px]">Nearest Neighbors</p>
                    </div>
                </div>
                <div className="w-full px-6 pb-6 h-full grow">
                    <ReactFlowProvider>
                        <RAFlowChart
                            readacrossData={readacrossData}
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}
                            searchInput={searchInput}
                            setSearchInput={setSearchInput}
                        />
                    </ReactFlowProvider>
                </div>
            </>
            )}
        </div>
    )
}